import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const AddressIcon = ({ color = '#8CA4C9', size = 25, ...props }) => (
  <svg width={size} height="30" viewBox="0 0 25 30" {...props}>
    <defs>
      <path
        d="M1.01 21.756A2.309 2.309 0 0 1 0 19.844a2.328 2.328 0 0 1 1.023-1.913l3.955-2.662a2.29 2.29 0 0 1 1.284-.394h2.059V13.5H3.212a2.313 2.313 0 0 1-2.314-2.306V5.825A2.329 2.329 0 0 1 3.212 3.5h5.109V1.038C8.32.456 8.795 0 9.38 0h5.614c.586 0 1.06.45 1.06 1.038v2.456h2.682c.456 0 .905.144 1.285.4l3.955 2.669A2.328 2.328 0 0 1 25 8.475a2.29 2.29 0 0 1-1.004 1.919L20.035 13.1c-.387.263-.836.4-1.304.4h-2.676v1.375h5.733a2.318 2.318 0 0 1 2.314 2.313v5.368a2.324 2.324 0 0 1-2.314 2.32h-5.733v4.086c0 .582-.474 1.038-1.06 1.038H9.381c-.586 0-1.06-.45-1.06-1.038v-4.087H6.275c-.468 0-.917-.144-1.303-.406L1.01 21.756zm12.925 6.12v-3h-3.493v3h3.493zM10.442 2.124V3.5h3.493V2.125h-3.493zm-7.423 9.069c0 .1.094.181.194.181h15.519a.21.21 0 0 0 .106-.031l3.96-2.706a.173.173 0 0 0 .081-.157.173.173 0 0 0-.08-.156l-3.955-2.662a.217.217 0 0 0-.106-.038H3.213c-.1 0-.194.094-.194.2v5.369zm7.423 2.306v1.375h3.493V13.5h-3.493zm-8.234 6.194c-.056.037-.087.087-.087.15 0 .068.025.118.081.156l3.961 2.712a.17.17 0 0 0 .106.038h15.525c.1 0 .193-.088.193-.194v-5.369a.19.19 0 0 0-.193-.187H6.27a.21.21 0 0 0-.106.031l-3.955 2.663z"
        id="address-icon-0"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="address-icon-b" fill="#fff">
        <use xlinkHref="#address-icon-0" />
      </mask>
      <path fill={color} mask="url(#address-icon-b)" d="M-5-5h35v40H-5z" />
    </g>
  </svg>
);

AddressIcon.propTypes = propTypes;

export default AddressIcon;
